import React, { useRef, useState } from "react";
import classes from "./NavbarSearchField.module.css";
import { useNavigate } from "react-router";

function NavbarSearchField() {
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const submitButtonRef = useRef();

  const searchArticles = (e) => {
    e.preventDefault();
    if (searchText !== "") {
      navigate(`/search?q=${searchText}`);
    }
  };

  return (
    <div className={`position-relative ${classes.navbarSearchFieldContainer}`}>
      <form onSubmit={searchArticles}>
        <input
          id="searchInputField"
          className={classes.NavbarSearchField}
          type="text"
          placeholder="search puplier..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          autoComplete="off"
        />
        <button ref={submitButtonRef} type="submit" hidden></button>
        <div
          onClick={() => submitButtonRef.current.click()}
          className={classes.mobileNavbarSearchButton}
        >
          <span className={`material-icons ${classes.mobileNavbarSearchIcon}`}>
            arrow_forward
          </span>
        </div>
      </form>
    </div>
  );
}

export default NavbarSearchField;
